<template>
  <el-dialog
    append-to-body
    title="欢迎登录!"
    :visible="visible"
    width="500px"
    custom-class="loginDialog"
    :close="close"
    :close-on-click-modal="false"
    :before-close="close"
  >
    <el-form
      :model="loginForm"
      :rules="rules"
      ref="loginForm"
      style="margin: 0 auto; width: 400px"
      label-width="70px"
    >
      <el-form-item label="用户名" prop="username">
        <el-input
          v-model="loginForm.username"
          placeholder="请输入用户名"
        ></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input
          v-model="loginForm.password"
          placeholder="请输入密码"
          type="password"
        >
          <i slot="suffix" class="el-input__icon el-icon-view"></i>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          size="small"
          style="width: 100%; margin-top: 10px"
          @click="login"
          >登 录</el-button
        >
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "LoginDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
      if (!this.$store.state.user.isLogin && this.$route.meta?.requireAuth) {
        this.$router.back();
      }
    },
    login() {},
  },
};
</script>

<style scoped lang="less" >
</style>